if (!customElements.get('carousel-component')) {
  class CarouselComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bb-fc-track');
      this.prevBtn = this.querySelector('.bb-fc-arrow--prev');
      this.nextBtn = this.querySelector('.bb-fc-arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;
      this.timer = null;

      if (!this.track) return;

      this.updateArrows();

      if (window.equalizeCardTitlesTrack) {
        window.equalizeCardTitlesTrack(this.track);
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByStep(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByStep(1));
      }

      this.track.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(this._scrollTimeout);
          this._scrollTimeout = window.setTimeout(() => {
            this.updateArrows();
          }, 80);
        },
        { passive: true }
      );

      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver(() => {
          this.updateArrows();
          if (window.equalizeCardTitlesTrack) {
            window.equalizeCardTitlesTrack(this.track);
          }
        });
        this._resizeObserver.observe(this.track);
      } else {
        window.setTimeout(() => this.updateArrows(), 300);
        window.addEventListener('load', () => this.updateArrows(), { once: true });
      }

      if (this.autoplay) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
    }

    get slides() {
      return Array.from(this.track.children);
    }

    slideWidth() {
      const first = this.slides[0];
      if (!first) return 0;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap || style.gap || '0');
      return first.getBoundingClientRect().width + gap;
    }

    scrollByStep(direction) {
      this.track.scrollBy({ left: direction * this.slideWidth(), behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.track || (!this.prevBtn && !this.nextBtn)) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
      if (this.nextBtn) this.nextBtn.disabled = maxScroll <= 0 ? false : this.track.scrollLeft >= maxScroll;
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = window.setInterval(() => {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.track.scrollLeft >= maxScroll) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollByStep(1);
        }
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  customElements.define('carousel-component', CarouselComponent);
}